import { Component } from '@angular/core';
import { CardViewComponent } from '../../card-view/card-view.component';
import { SabisNgxDialogComponent } from 'sabis-components2';

@Component({
  selector: 'sca-email-tags',
  templateUrl: './email-tags.component.html',
  styleUrls: ['./email-tags.component.scss'],
  imports: [
    CardViewComponent,
    SabisNgxDialogComponent
  ]
})
export class EmailTagsComponent {
  public title: string = "Email Tags"
}
